module.exports = __webpack_public_path__ + "static/media/card-front@2x.a1333375.png";